import { ClientOptionError } from "./client-option-error";

export class ClientOptions {
    

    constructor() {

    }

    // -------------------- baseUrl --------------------

    private _baseUrl: string | null = null;

    /**
     * 
     * @throws QqAwsServiceStudioClientClientError  When the baseurl is not set
     */
    get baseUrl(): string {
        if (this._baseUrl === null) {
            throw new ClientOptionError("Option not set", 'baseUrl');
        };
        return this._baseUrl;
    }

    setBaseUrl(value: string) : ClientOptions {
        // Normalize URL (trailing slash)
        this._baseUrl = value.replace(/\/$/, "");
        return this;
    }

    // -------------------- apiKey --------------------

    private _apiKey : string | null = null;

    /**
     * @returns The apiKey
     * @throws QqAwsServiceStudioClientClientError  When the apiKey is not set
     */
    get apiKey(): string {
        if (this._apiKey === null) {
            throw new ClientOptionError("Option not set", 'apiKey');
       };
        return this._apiKey;
    }

    /**
     * 
     * @param value The API key
     * @returns 
     */
    setApiKey(value: string) : ClientOptions {
        this._apiKey = value;
        return this;
    }

}